import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const WorkshopOnlineOffline = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="WorkshopOnlineOffline" />
                    <HerosectionsAll ScreenName="Training Methodology" ScreenSearch="Methodology" />

                    <div className="row col-lg-10 mx-auto p-2 px-lg-5 py-lg-5 my-5 ">
                        <div className="col-12 p-lg-5 p-4 faint" style={{textAlign: 'justify'}}>
                            <h5 className="fw-bold gray_color pb-3">Training Methodology</h5>
                            <p>We use a variety of instructional designs (ID) for our clients. As insurance is a vast and complex subject to understand, this ID helps learners to boost their enthusiasm while assisting them in transitioning from basic knowledge to complex claim settlements and intricacies of subject. </p>
                            <p>ID modes like as ARCS, motivating design models, and the CCAF model encourage students to learn through challenging learning experiences. All training concepts are based on Andragogy learning, which enables students to learn quickly.</p>
                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
